import React from 'react';
import { Box, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import type { SxProps } from '@mui/system';

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import CustomTooltip from './CustomTooltip';

type TagColor = 'primary' | 'secondary' | 'success' | 'danger';
export interface TagProps {
	text: string;
	sx?: SxProps<Theme>;
	tooltip?: string;
	color?: TagColor;
}

const Tag = (props: TagProps) => {
	const classes = useStyles({ color: props.color ?? 'primary' });

	const content = (
		<Box className={classes.tag} sx={props.sx}>
			<Typography className={classes.tagText} variant="button">
				{props.text}
			</Typography>
		</Box>
	);

	return !!props.tooltip ? <CustomTooltip title={props.tooltip}>{content}</CustomTooltip> : content;
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		tag: {
			background: ({ color }: { color: TagColor }) =>
				color === 'primary'
					? theme.palette.primary.lightest
					: color === 'secondary'
					? theme.palette.background.secondary
					: color === 'danger'
					? theme.palette.error.lightest
					: color === 'success'
					? theme.palette.success.lightest
					: theme.palette.primary.lightest,
			color: theme.palette.text.primary,
			borderRadius: '16px',
			display: 'inline-block',
		},
		tagText: {
			fontSize: '1.3rem',
			lineHeight: '1.3rem',
			fontWeight: 400,
			display: 'block',
			padding: '8px 12px',
			textTransform: 'none',
		},
		tooltip: {
			fontSize: '14px',
			padding: theme.spacing(1, 0, 1, 1),
			background: theme.palette.common.black,
			color: theme.palette.common.white,
		},
		tooltipArrow: {
			color: theme.palette.common.black,
		},
	}),
);

export default Tag;
